import { gql } from 'graphql-tag'
// import preview from '../../../core/config/preview'
import { fragmentModuleMedia, fragmentModuleNavigationLink } from '../../../core/data-layer/modules/fragments'
import queryPageFields from '../../../core/data-layer/pages/page/query-page-fields'

// excluded preview from the query
export default gql`
  ${fragmentModuleMedia}
  ${fragmentModuleNavigationLink}
  query($slug: String!, $locale: String!, $preview: Boolean!) {
    page: pagePressAndMediaDetailCollection(limit: 1, where: { slug: $slug }, locale: $locale, preview: $preview) {
      items {
        ${queryPageFields}
        introText {
          json
        }
        text {
          json
        }
        disclaimer {
          json
        }
        date
        city {
          sys {
            id
          }
          name
        }
        image {
          ...ModuleMediaFragment
        }
        fpZoom
        downloadableImage
      }
    }
    pageParent: pagePressAndMediaCollection(limit: 1, locale: $locale, preview: $preview){
      items {
        newsroomLink {
          ...ModuleNavigationLinkFragment
        }
      }
    }
  }
`
